import { FormWrapper } from "../FormWrapper";
import Space from "../Space";
import ReservationSummary from "../ReservationSummary";
import { ResponsiveStack } from "../ResponsiveStack";
import { ReservationState } from "../../util/useReservationState";
import { FloatingConfirmUI } from "../FloatingUI";
import useEventId from "../../util/useEventId";
import { useApiContext } from "../../api/ApiProvider";

export default function Form3({ state }: { state: ReservationState }) {
  const { api } = useApiContext();
  const eventId = useEventId();
  const onPrev = () => {
    state.setValue("confirmed", false);
  };

  const onNext = () => {
    if (state.data.posted) {
      return;
    }
    state.setValue("posted", true);
    api.PostReserve(state.data, eventId, new URLSearchParams(window.location.search)).then((response) => {
      if (response) {
        state.setValue("rid", response.rid);
        state.setValue("lineLoginUrl", response.line_login_url);
        state.setValue("accepted", true);
      } else {
        state.setValue("error", true);
      }
    });
  };

  if (!state.data.store || !state.data.course || !state.data.date) {
    state.setValue("error", true);
    return <></>;
  }

  return (
    <FormWrapper currentIndex={2} skipConfirm={state.data.store?.skip_confirm}>
      <ReservationSummary data={{ ...state.data, store: state.data.store, nominated_staff_name: state.data.staff?.nominee_name, course: state.data.course, date: state.data.date }} />
      <Space h={250} />
      <ResponsiveStack style={{ alignItems: "center", gap: 10 }} columnReverse>
        <FloatingConfirmUI onPrev={onPrev} onNext={onNext} />
      </ResponsiveStack>
    </FormWrapper>
  );
}
